import type {
  AtLeast,
  Block,
  DateBlock,
  ListView,
} from '@basehub/data/replicache/index'
import { InputProps } from '~/sotano-kit/primitives/input'

export { filter } from '@basehub/data/db/list-helpers/filter'

export const getFilterInputProps = ({
  filter,
  block,
}: ({ block: AtLeast<Block, 'type'> } | { block: DateBlock }) & {
  filter: ListView['filter'][number]
}): InputProps => {
  if (filter.type === 'and' || filter.type === 'or') {
    throw new Error('and/or not supported yet')
  }

  const readOnly = filter.type === 'is-empty' || filter.type === 'is-not-empty'

  if (block.type === 'select' || block.type === 'reference') {
    return {
      type: 'text',
      readOnly,
      placeholder: readOnly ? '' : 'Tip: concat using commas (,)',
      value: readOnly ? 'True' : filter.value,
      size: 'xs',
    }
  }

  if (['audio', 'video', 'image', 'file'].includes(block.type)) {
    const inputTypeShouldBeNumber =
      filter.type === 'greater-than' || filter.type === 'lower-than'

    return {
      placeholder: inputTypeShouldBeNumber ? 'MB' : '',
      size: 'xs',
      readOnly,
      type: !inputTypeShouldBeNumber ? 'text' : 'number',
      value: readOnly ? 'True' : filter.value,
    }
  }

  if (block.type === 'list') {
    const inputTypeShouldBeNumber =
      filter.type === 'greater-than' || filter.type === 'lower-than'

    return {
      placeholder: 'x rows',
      size: 'xs',
      readOnly,
      type: !inputTypeShouldBeNumber ? 'text' : 'number',
      value: readOnly ? 'True' : filter.value,
    }
  }

  if (block.type === 'number') {
    return {
      placeholder: 'Compare to',
      size: 'xs',
      readOnly,
      type: 'number',
      value: readOnly ? 'True' : filter.value,
    }
  }

  if (block.type === 'date') {
    return {
      value: readOnly ? 'True' : filter.value,
      readOnly,
      type: (block as DateBlock).typeOptions.useTime
        ? 'datetime-local'
        : 'date',
      size: 'xs',
    }
  }

  return {
    type: 'text',
    size: 'xs',
    value: readOnly ? 'True' : filter.value,
    readOnly,
  }
}
